<p style="color: #6e5e5e; padding: 0; margin: 0; font-size: 12px">
  {{version}}
</p>
<ng-content></ng-content>
